export const ru = {
  mic: 'Микрофон',
  camera: 'Камера',
  shareScreen: 'Демонстрация',
  stopShare: 'Стоп демо',
  chat: 'Чат',
  assistant: 'AGIMA Bot',
  assistantTitle: 'AGIMA Bot и умный помощник встречи',
  assistantAgenda: 'Повестка',
  assistantHints: 'Подсказки',
  assistantHeard: 'Реплики',
  assistantShowHeard: 'Показать реплики',
  assistantShow: 'Показать',
  assistantHide: 'Скрыть',
  assistantWaiting: 'Помощник подключается, повестка появится через несколько секунд.',
  assistantNoAgenda:
    'Пунктов повестки нет: контекст встречи пуст. Помощник будет только подсказывать.',
  assistantNoHints: 'Подсказок пока нет.',
  assistantClockWaiting: 'Время пойдёт с первой реплики',
  assistantBehindPlan: 'отстаём на',
  assistantAheadPlan: 'опережаем на',
  assistantMore: 'ещё',
  assistantHintsCount: 'подсказок:',
  assistantDoneWhen: 'Закрыто, когда',
  assistantHideHeard: 'Скрыть реплики',
  assistantNotRunning: 'Помощник не запущен',
  assistantStart: 'Запустить помощника',
  agendaEmpty: 'Повестки пока нет. Её составит AGIMA Bot — тогда помощник будет отмечать, что обсудили, и подсказывать, что упущено.',
  agendaEmptyShort: 'Повестки нет — её составит AGIMA Bot.',
  assistantNoAgendaShort: 'Повестки нет, помощник только подсказывает.',
  agendaHelp: 'Как работает повестка',
  agendaEmptyStep1: 'Вставьте в поле внизу переписку, КП, бриф или просто опишите цель встречи.',
  agendaEmptyStep2: 'Нажмите «Чеклист встречи» — бот задаст пару уточняющих вопросов и запишет пункты.',
  agendaEmptyStep3: 'Помощник подключится к звонку сам; запустить его можно и сразу — кнопкой вверху.',
  agendaEmptyStep3Running: 'Помощник уже в звонке: чеклист он подхватит сразу, отметки пойдут с текущего момента.',
  assistantStarting: 'Запускаю…',
  botLoading: 'Загружаю чат…',
  botDisabled: 'Чат с ботом недоступен: Octor не нашёл эту встречу. Обновите страницу.',
  botEmpty:
    'Бот знает эту встречу, Jira и онтологию. Спросите «Что это за встреча?», нажмите «Чеклист встречи» — когда чеклист готов, помощник подключится к звонку сам.',
  botMaterials: 'Материалы, знаков',
  botSending: 'Отправляю запрос',
  botSeconds: 'с',
  botQueued: 'ждёт очереди',
  botQueuedHint: 'Бот занят запросами из Mattermost и Jira; ваш запрос начнётся сам.',
  botRetry: 'Повторить',
  botUnavailable: 'AGIMA Bot не подключён к этому Octor.',
  botAnswering: 'AGIMA Bot отвечает…',
  botPlaceholder: 'Спросите AGIMA Bot или вставьте материалы для чеклиста',
  botInputHint: 'Enter — отправить, Shift+Enter — новая строка',
  botStop: 'Остановить',
  botAnswerFor: 'ответ для',
  botAnsweringFor: 'AGIMA Bot отвечает:',
  assistantPriority: 'минимум',
  assistantNow: 'сейчас',
  assistantMinutes: 'мин',
  assistantGeneralHints: 'Общие подсказки',
  assistantHintResolved: '✓ решено',
  assistantTimingHint: 'Время',
  assistantQuestionHint: 'Вопрос комиссии',
  assistantSpeakerHint: 'Спикер',
  assistantSpeaker: 'говорит',
  assistantRehearsal: 'Репетиция защиты',
  newChatMessage: 'Новое сообщение',
  raiseHand: 'Поднять руку',
  lowerHand: 'Опустить руку',
  raisedHand: 'Поднятая рука',
  handRaisedToast: 'Поднял руку',
  settings: 'Настройки',
  leave: 'Выйти',
  messages: 'Сообщения',
  messagePlaceholder: 'Напишите сообщение…',
  send: 'Отправить',
  connecting: 'Подключение…',
  reconnecting: 'Переподключение…',
  disconnected: 'Нет соединения',
  startMedia: 'Разрешить звук и видео',
  admin: 'Админка',
  mediaDevices: 'Устройства',
  recording: 'Запись',
  speakerHeadphones: 'Динамики и наушники',
  audioOutput: 'Выход звука',
  recordMeeting: 'Запись встречи',
  recordingActive: 'Встреча сейчас записывается',
  recordingIdle: 'Запись этой встречи не идёт',
  startRecording: 'Начать запись',
  stopRecording: 'Остановить запись',
  close: 'Закрыть',
  collapseSelfVideo: 'Свернуть своё видео',
  expandSelfVideo: 'Развернуть своё видео',
  collapsedSelfVideo: 'Своё видео свёрнуто',
  backgroundEffects: 'Фон',
  backgroundNone: 'Нет',
  backgroundBlur: 'Размытие',
  backgroundBlurStrong: 'Сильнее',
  backgroundDesk: 'Стол',
  backgroundNature: 'Природа',
  backgroundUnsupported: 'Виртуальный фон в этом браузере недоступен.',
  backgroundApplying: 'Применяем фон…',
  backgroundFailed: 'Не удалось применить фон. Попробуйте ещё раз.',
  backgroundCameraOff: 'Включите камеру, чтобы увидеть фон.',
  backgroundUpload: 'Загрузить свой',
  backgroundCustom: 'Мой фон',
  backgroundRemove: 'Удалить фон',
  backgroundUploadInvalid: 'Можно загрузить только изображение.',
  backgroundUploadTooLarge: 'Файл больше 20 МБ. Выберите изображение поменьше.',
  backgroundUploadTooLargeResolution:
    'Изображение слишком большого разрешения. Выберите изображение поменьше.',
  backgroundStorageFull: 'Можно сохранить до 10 фонов. Удалите старые, чтобы добавить новый.',
  backgroundUploadFailed: 'Не удалось обработать изображение. Попробуйте другое.',
  backgroundSaveFailed:
    'Фон применён, но сохранить его не удалось: после перезагрузки страницы он пропадёт.',
  backgroundRemoveFailed: 'Не удалось удалить фон. Попробуйте ещё раз.',
  noiseOn: 'Выключить шумоподавление',
  noiseOff: 'Включить шумоподавление',
  e2eeUnsupported:
    'Эта встреча с шифрованием, но браузер его не поддерживает. Обновите браузер и попробуйте снова.',
  unexpectedError: 'Произошла ошибка. Подробности — в консоли.',
  encryptionError: 'Ошибка шифрования. Подробности — в консоли.',
};
